<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UE68u9/tc-custom/FC-9781528968676.jpg?1684514756019?1705540958230" alt="This image is the cover for the book Fragments of an Everywoman's Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fragments of an Everywoman's Life
      </h1>
      <p class="bookDescription body article font2">
        <p>In her groundbreaking first book, author Eileen Ballman proves she herself is an 'Everywoman' in every sense of the word. By drawing on relatable, personal experiences such as childhood, growing pains, education, careers, marriage, parenthood, and gracefully aging, her exploration of the myriad ways women handle life's milestones offers a compelling, evocative, and emotive read. Jesting she is Shakespeare's sister, she quickly draws the reader into her stories and musings as she demonstrates her love of the "human condition"; the bond and friendship which develops between the author and the reader is immediate and gratifying. Her unique hybrid approach to memoir/self-help journaling will change how readers view these genres. Because she seeks the reader's opinion of her own handling of various situations, the reader advances from the sidelines to the forefront. Encouraged to document their personal accounts on the pages provided, readers now find themselves an integral and valuable part of a storyline. As she tackles challenging subjects such as 'How Far Will You Go', 'Loss of Innocence', 'Bouncing Back', and 'Defining Moments', Ms. Ballman reveals her extensive knowledge of the complexity of life's challenges, as well as her authentic compassion for the female role. Characterizing herself as an 'Everywoman', she notes, "Although we may not be prominent, notable figures ourselves, our universally relatable stories certainly are, and this ability to relate creates our impregnable bond."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eileen Ballman
      </h2>
      
      <p class="authorDescription body article">Eileen Ballman was raised in Cheshire, Connecticut. She was the middle child in her large Irish Catholic family of eight. She's learned about life through her three distinct careers in sales, interior design, and teaching. After joining the military in the mid-seventies, she landed on the West Coast where she got married, raised her children, and lived joyfully for 22 years between Washington and Oregon. She and her family moved to North Carolina in 2000, and after retiring from teaching in 2012, she now resides in St Augustine, Florida, with her husband, Dave. She has two sons, Jake and Josh, and has a host of 'everywoman' friends who keep her happy and sane in her beloved beach town.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f3ea73e